/**
 * patrol-apprehension-view.js
 */

import React from 'react';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import { PatrolTypeTitle } from '../../training-utils';


export default function PatrolAgilityView(props) {
  const { record, patrolTypes } = props;
  const agility = record.agility;


  return (
    <>
      {record &&
      <IconSection iconName='patrol-agility'>
        <PatrolTypeTitle 
          patrolType={record.type} 
          patrolTypes={patrolTypes} 
          step={record.order}
        />
        
        <InfoRow title='Actions Performed' text={agility.types.map(type => type.customOtherName || type.name).join(', ')} />
      </IconSection>}
    </>
  );
}